/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import "./corresponding-cross-component.scss";
import PropTypes from "prop-types";
import Popup from "reactjs-popup";
import { useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import DragDropColumns from "./DragDropColumns";
import CancelIcon from "../../common/Icons/Cancel/CancelIcon";
import t from "../../../utils/common/translation/translator";
import Select from "../../common/Inputs/Select/Select";
import { selectRowsToShow, setRowsToShow } from "../../../store/slices/retrofit";
import MsxIcons from "../../common/Icons/MsxIcons/MsxIcons";

const contentStyle = {
  maxWidth: "90%",
  maxHeight: "90%",
  display: "flex"
};

function mapSelectedColumns(columns) {
  return columns.map((column) => column.columns);
}

const PersonnalisationPopup = ({
  choosableColumns,
  columns,
  colKeyToName,
  updateCustomGroupsAndColumns,
  isFetchingBundles
}) => {
  const [selectedColumns, setSelectedColumns] = useState(mapSelectedColumns(columns));

  const queryClient = useQueryClient();

  const dispatch = useDispatch();
  const rowsToShow = useSelector(selectRowsToShow);
  const [numberOfRowsToShow, setNumberOfRowsToShow] = useState(rowsToShow);

  return (
    <Popup
      trigger={
        <button className="cross-component-button text-secondary flex items-center space-x-1" type="button">
          <MsxIcons name="action_settings" />
          <span className="">{t("msizer.ui.customize_table")}</span>
        </button>
      }
      modal
      contentStyle={contentStyle}
    >
      {(close) => (
        <div
          className="modal rounded-md"
          style={{
            minWidth: "750px"
          }}
        >
          <div className="header">
            <span>{t("msizer.ui.popup.customization.title")}</span>
            <button className="close" onClick={close} type="button">
              <CancelIcon color="#333" size={12} />
            </button>
          </div>
          <div
            className="ccc-popup-content p-2 space-y-4"
            style={{
              overflow: "auto",
              maxHeight: "400px"
            }}
          >
            <div>
              <span className="text-lg font-semibold mb-1 text-secondary">
                {t("msizer.ui.popup.customization.customize_rows")}
              </span>
              <div className="w-1/2">
                <Select
                  id="RowsToShow"
                  label={t("msizer.ui.popup.customization.number_of_rows")}
                  options={[
                    {
                      label: "10",
                      key: "10"
                    },
                    {
                      label: "25",
                      key: "25"
                    },
                    {
                      label: "50",
                      key: "50"
                    },
                    {
                      label: "75",
                      key: "75"
                    },
                    {
                      label: `100 (${t(t("msizer.ui.popup.customization.performance_impact"))})`,
                      key: "100"
                    },
                    {
                      label: `200 (${t(t("msizer.ui.popup.customization.performance_impact"))})`,
                      key: "200"
                    }
                  ]}
                  initValue={numberOfRowsToShow}
                  changeWithInit
                  onSelect={(value) => {
                    setNumberOfRowsToShow(Number(value));
                  }}
                />
              </div>
            </div>
            <hr />
            <div>
              <span className="text-lg font-semibold mb-1 text-secondary">
                {t("msizer.ui.popup.customization.customize_columns")}
              </span>
              <DragDropColumns
                choosableColumns={choosableColumns}
                columns={mapSelectedColumns(columns)}
                fullColumns={columns}
                colKeyToName={colKeyToName}
                updateSelectedColumns={setSelectedColumns}
              />
            </div>
          </div>
          <div className="actions space-x-2">
            <qds-button
              onClick={() => {
                close();
              }}
              text={t("msizer.ui.popup.button.cancel")}
            ></qds-button>
            <qds-button
              importance="emphasized"
              onClick={() => {
                updateCustomGroupsAndColumns(selectedColumns);
                dispatch(setRowsToShow(numberOfRowsToShow));
                if (isFetchingBundles) {
                  queryClient.cancelQueries("FETCH_BUNDLES");
                }
                close();
              }}
              text={t("msizer.ui.popup.button.save")}
            ></qds-button>
          </div>
        </div>
      )}
    </Popup>
  );
};

PersonnalisationPopup.propTypes = {
  colKeyToName: PropTypes.func,
  updateCustomGroupsAndColumns: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.any),
  choosableColumns: PropTypes.arrayOf(PropTypes.any),
  isFetchingBundles: PropTypes.bool
};

PersonnalisationPopup.defaultProps = {
  columns: [],
  choosableColumns: [],
  colKeyToName: () => {},
  updateCustomGroupsAndColumns: () => {},
  isFetchingBundles: false
};

export default PersonnalisationPopup;
